<div class="container">
  <div class="door-list mt-3 mb-3" *ngIf="workPlaces.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name</th>
        <th scope="col">Room</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let workPlace of workPlaces">
        <th scope="row">{{workPlace.id}}</th>
        <td>{{workPlace.name}}</td>
        <td>{{workPlace.roomName}}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(workPlace)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(workPlace)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
